import { firestore, collection, getDocs, addDoc, doc, updateDoc, deleteDoc, query, where, getDoc, collectionGroup, setDoc, limit, orderBy } from '../../utils/firestore'

const firestoreGetAllDocsCollection = async (collectionName) => getDocs(getCollectionRef(collectionName))

const firestoreGetQueriedDocsCollection = async (collectionName, fieldName, operator, value) => getDocs(query(getCollectionRef(collectionName), where(fieldName, operator, value)))

// const firestoreGetCompoundQueriedDocsCollection = async (collectionName, queryConstraints) => getDocs(query(collection(firestore, collectionName), ...queryConstraints));

const firestoreGetDoc = async (collectionName, docId) => getDoc(doc(firestore, collectionName, docId))

const queryDocs = async (collectionName, query) => {
  let fieldName, operator, value
  return getDocs(query(collection(firestore, collectionName), where(fieldName, operator, value)))
}

const firestoreAddDoc = async (collectionName, data) => addDoc(getCollectionRef(collectionName), data)

const firestoreUpdateDoc = async (collectionName, id, data) => updateDoc(doc(firestore, collectionName, id), data)

const firestoreDeleteDoc = async (collectionName, id) => deleteDoc(getCollectionRef(collectionName), id)

const getCollectionRef = (collectionName) => {
  return collection(firestore, collectionName)
}

export const getTemplateTypesForWms = async (wms) => {
  const standTemplateQuery = query(collection(firestore, 'gdeTemplates'), where('templateType', '==', 'STANDARD'), where('wms', '==', wms.toUpperCase()))
  return getDocs(standTemplateQuery)
}

export const getTemplatesForDeType = async (deType, wms) => {
  const templateQuery = query(collection(firestore, 'gdeTemplates'), where('deType', '==', deType), where('wms', '==', wms.toUpperCase()))
  return getDocs(templateQuery)
}

export const getWmsSystemFroCountry = async (countryCode) => {
  const buildingCollectionQuery = query(collectionGroup(firestore, 'buildings'), where('countryCode', '==', countryCode))
  return getDocs(buildingCollectionQuery)
}

export const getLocationsForCountry = async (countryName) => {
  const locationsQuery = query(collection(firestore, 'locations'), where('country', '==', countryName))
  return getDocs(locationsQuery)
}

export const getCountries = async () => {
  return getDocs(collection(firestore, 'countries'))
}

export const getWorkerDetails = async (userId) => {
  return getDoc(doc(firestore, 'workers', userId))
}

export const createTemplate = async (data) => {
  return setDoc(doc(firestore, 'gdeTemplates', data.templateCustomName), data)
}

export const createJob = async (data) => {
  return addDoc(collection(firestore, 'gdeTransactions'), data)
}

export const getQueryData = async (status) => {
  const first = query(collection(firestore, 'gdeTransactions'), where('status', '!=', status), orderBy('status'), limit(20))
  // const documentSnapshots = await getDocs(first)
  // const lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1]
  // const next = query(collection(firestore, 'gdeTransactions'), where('status', '!=', 'Approved'), orderBy('status'), startAfter(lastVisible), limit(20))
  return getDocs(first)
}
// return firestoreGetQueriedDocsCollection('gdeTransactions', 'status', '==', 'Entry')
export const getJobById = async (jobId) => {
  return getDoc(doc(firestore, 'gdeTransactions', jobId))
}

export const getCountryByID = async (countryId) => {
  return getDoc(doc(firestore, 'countries', countryId))
}

export const getTemplateById = async (templateId) => {
  return getDoc(doc(firestore, 'gdeTemplates', templateId))
}


export const updateWorkerDistrict = async (workerId, newDistrict, countryCode, countryName) => {
  const districtList = [newDistrict]

  const workerData1 = {
    gdeDistrict: newDistrict
  }
  updateDoc(doc(firestore, `workers/${workerId}`), workerData1)

  const workerData2 = {
    district: districtList,
    gdeCountryCode: countryCode,
    gdeCountry: countryName,
  }
  return updateDoc(doc(firestore, `workers/${workerId}/workerRoles/gde`), workerData2)
}

export const rememberSelection = async (workerId, data) => {
  return updateDoc(doc(firestore, `workers/${workerId}/workerRoles/gde`), data)
}

export { firestoreGetAllDocsCollection, firestoreGetQueriedDocsCollection, firestoreAddDoc, firestoreUpdateDoc, firestoreDeleteDoc, firestoreGetDoc, queryDocs, getCollectionRef }